import { render, staticRenderFns } from "./exception.vue?vue&type=template&id=712555d3&scoped=true&"
import script from "./exception.vue?vue&type=script&lang=js&"
export * from "./exception.vue?vue&type=script&lang=js&"
import style0 from "./exception.vue?vue&type=style&index=0&id=712555d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712555d3",
  null
  
)

export default component.exports